// 分页
const PAGE_SIZE = 10;
const PAGE_SIZES = [10, 20, 30];
const LABEL_SUFFIX = ' :';

export { PAGE_SIZE, PAGE_SIZES, LABEL_SUFFIX };
